import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavParams, Platform } from '@ionic/angular';
import { log } from 'console';
import { delay } from 'rxjs/operators';
import { Navigator } from 'src/app/components/menu/navigator';
import { BalanceModel } from 'src/app/models/balance-model';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { RedirectService } from 'src/app/services/redirect/redirect.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-alert-notification',
  templateUrl: './alert-notification.component.html',
  styleUrls: ['./alert-notification.component.scss'],
})
export class AlertNotificationComponent implements OnInit {
  imageUrl: string;
  image: string;
  data: any;
  title: string;
  htmlText: string;
  content: string;

  constructor(
    public userSession: UserSessionService,
    private navigator: Navigator,
    private sanitizer:DomSanitizer,
    private utils:UtilsService,
    private navParams: NavParams,
    private redirectService: RedirectService
  ) { }

  ngOnInit(): void {
    this.imageUrl = `/notifications/${this.data.notificationImage}`;
    this.data =  this.navParams.data.data;
    
    try {
      this.data.extraData = JSON.parse(this.data.extraData); // extraData is a stringified JSON object
    } catch (error) {
      console.error('Failed to parse extraData:', error);
    }
    
    if(!!this.data.title){
      this.title = this.getEmojiFromUTF16(this.data.title);
    }
    if(!!this.data.content){
      this.content = this.getEmojiFromUTF16(this.data.content);
    }
    if(!!this.data.htmlText){
      this.htmlText = this.getEmojiFromUTF16(this.data.htmlText);
    }
    
    if(!!this.data.notificationImage){
      this.image = this.utils.getCDNAsset(this.imageUrl)
    }
    if (this.data.timeout) {
      setTimeout(()=>{
        this.onClosePopover();
      },+this.data.timeout);
    }
  }

  // Method to replace all 'U+' with '&#x' and append ';'
  replaceUnicodeToHtmlEntity(input: string): string {
    return input.replace(/U\+([0-9A-F]+)/g, '&#x$1;');
  }


  getEmojiFromUTF16(utf16Str: string): string {
    return utf16Str.replace(/\\u([A-Fa-f0-9]{4})\\u([A-Fa-f0-9]{4})/g, (match, p1, p2) => {
      const highSurrogate = parseInt(p1, 16); 
      const lowSurrogate = parseInt(p2, 16); 
      return String.fromCodePoint((highSurrogate - 0xD800) * 0x400 + (lowSurrogate - 0xDC00) + 0x10000);
    });
  }

  onImageClick(): void {
    if(this.data?.extraData?.click_action === 'freecoins' && this.data?.extraData?.promo_code){
      this.onClosePopover(); // close the popover and handle the click action in onDestroy
    }
  }

  public onClosePopover() {
    this.navigator.dismiss();
  }

  get sanitizedHtmlText() {
    // we need to process html becaise of emojis
    let processedHtml = this.decodeHTML(this.htmlText);
    return this.sanitizer.bypassSecurityTrustHtml(processedHtml);
  }

  decodeHTML = function (html) {
    var txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  };

  ngOnDestroy() {
     if(this.data?.extraData?.click_action === 'freecoins' && this.data?.extraData?.promo_code){
        this.redirectService.deepLinkToPromos(this.data.extraData.promo_code);
     }
  } 
}
